goog.provide("shadow.js.shim.module$$mui$material$Tab$default");
shadow.js.shim.module$$mui$material$Tab$default = shadow.js.shim.module$$mui$material$Tab.default;
